export async function apiGet(route){
  const URL = `${process.env.REACT_APP_SERVER_ADDRESS}/${route}${route.includes("?") ? "" : "?"}&key=${process.env.REACT_APP_SERVER_API_KEY}`;
  const result = await fetch(URL)
  return result
}

export async function apiPost(route, body){
  const URL = `${process.env.REACT_APP_SERVER_ADDRESS}/${route}${route.includes("?") ? "" : "?"}&key=${process.env.REACT_APP_SERVER_API_KEY}`;
  const result = await fetch(URL, {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(body)
  })
  return result
}

export async function filePost(route, body){
  const URL = `${process.env.REACT_APP_SERVER_ADDRESS}/${route}${route.includes("?") ? "" : "?"}&key=${process.env.REACT_APP_SERVER_API_KEY}`;
  const result = await fetch(URL, {
    method: 'POST',
    body: JSON.stringify(body)
  })
  return result
}

export async function apiPut(route, body){
  const URL = `${process.env.REACT_APP_SERVER_ADDRESS}/${route}${route.includes("?") ? "" : "?"}&key=${process.env.REACT_APP_SERVER_API_KEY}`;
  const result = await fetch(URL, {
    method: 'PUT',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(body)
  })
  return result
}

export async function apiDelete(route, body){
  const URL = `${process.env.REACT_APP_SERVER_ADDRESS}/${route}${route.includes("?") ? "" : "?"}&key=${process.env.REACT_APP_SERVER_API_KEY}`;
  const result = await fetch(URL, {
    method: 'DELETE',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(body)
  })
  return result
}